var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopRightGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0192 3.56833L1.75958 19.8121C1.55875 20.0129 1.31569 20.1106 1.03042 20.105C0.745139 20.0997 0.502083 19.9967 0.30125 19.7958C0.100416 19.595 0 19.3568 0 19.0813C0 18.8057 0.100416 18.5632 0.30125 18.3538L16.545 2.09417H1.99333C1.69667 2.09417 1.44806 1.99319 1.2475 1.79125C1.04694 1.58958 0.946667 1.33958 0.946667 1.04125C0.946667 0.743194 1.04694 0.495139 1.2475 0.297084C1.44806 0.099028 1.69667 0 1.99333 0H18.8096C19.179 0 19.4886 0.124861 19.7383 0.374583C19.9881 0.624583 20.1129 0.934168 20.1129 1.30333V18.1196C20.1129 18.4163 20.0121 18.665 19.8104 18.8658C19.6088 19.0664 19.3588 19.1667 19.0604 19.1667C18.7621 19.1667 18.514 19.0664 18.3162 18.8658C18.1182 18.665 18.0192 18.4163 18.0192 18.1196V3.56833Z",
    fill: "#00201A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightGreen);
export default __webpack_public_path__ + "static/media/top-right-green.4dc95ea167cf729ce7fdf63c3e9e5e79.svg";
export { ForwardRef as ReactComponent };